<template>
  <div class="callNumPage">
    <Row :gutter="24" class="callNumPageRow">
      <!-- 左边栏目 -->
      <Col class="leftContent">
        <div class="cateTabs" v-if="devices.length >= 0">
          <Tabs tabPosition="top" width="500px" :defaultActiveKey="defaultDeviceId" @change="changCheckCate" @prevClick="()=>{}" @nextClick="()=>{}">
            <TabPane v-for="device in devices" :key="device.id" :tab="device.name">
              <queueLists ref="queue" :dataList="dataSource" @selectTableItem="selectTableItem" :defaultDeviceId="defaultDeviceId"></queueLists>
            </TabPane>
            <div slot="tabBarExtraContent" class="calendarWrap">
              <Icon type="left" @click="getLastDayTime" style="margin-right:10px;font-size:16px"/>
              <DatePicker :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" placeholder="请选择日期" v-model="queueDate" @change="selectQueueDate"/>
              <Icon type="right" @click="getNextDayTime" style="margin-left:10px;font-size:16px"/>
            </div>
          </Tabs>
        </div>
      </Col>
      <!-- 右边栏目 -->
      <Col class="rightContent">
        <Card class="static">
          <div class="pageNumShow"><span>等待叫号：{{staticData.callNum}}</span> 当日检查单数：{{staticData.todayCheckNum}}</div>
        </Card>
        <Card class="mainOperate">
          <Button type="primary" v-if="[60, 50].includes(selectItem.status)" :disabled="[50].includes(selectItem.status)" size="large" @click="completeScanning">完成扫描</Button>
          <Button type="primary" v-else size="large" :disabled="[-20, 60, 20].includes(selectItem.status)" @click="callPatient">呼叫患者</Button>
        </Card>
        <Card class="operateCard">
          <Button size="large" :disabled="[10, -20].includes(selectItem.status) || !(this.selectItem.settlementStatus === 0 || this.isRole('ROLE_ROOT'))" @click="setWorkMan">设置工作人</Button>
          <Button size="large" :disabled="[-20].includes(selectItem.status)" style="margin-left: 16px;" @click="editCheck">编辑详情</Button><br/>
          <Button size="large" :disabled="[10, 60, -20].includes(selectItem.status)" @click="mateImage">匹配影像</Button>
          <Button size="large" :disabled="[-20].includes(selectItem.status)" @click="seeMessage" style="margin-left: 16px;">查看资料</Button><br/>
          <Button size="large" :disabled="[10, 50, -20].includes(selectItem.status)" @click="cancelScanning">取消扫描</Button>
          <Button size="large" :disabled="!selectItem.reportId" @click="printReport" style="margin-left: 16px;">打印报告</Button>
        </Card>
        <Card class="checkPatient">
          <p>编写医生：{{selectItem.writeReportDoctor | changeDoctorName('write')}}</p>
          <p>审核医生：{{selectItem.reviewReportDoctor | changeDoctorName('check')}}</p>
          <p>AI算法：<span v-for="val in selectItem.aftertreatment" :key="val.id">{{`${val.item}-${afterHandler(val.type)}-${val.automatic},`}}</span></p>
          <p>既往病史：{{selectItem.medicalHistory}}</p>
          <p>备注：{{selectItem.remark}}</p>
        </Card>
      </Col>
    </Row>
    <Modal title="匹配影像" v-model="showMateImage" :footer="null" @cancel="handleCancel" :width="900" class="modalFixdToTop">
      <MateImage :checkOrderId="checkOrderId" @closeModal="closeModal" v-if="showMateImage"></MateImage>
    </Modal>
    <Modal title="呼叫患者" v-model="showCallPatient">
      <h3>患者是否已经进入检查室？</h3>
      <div slot="footer" class="footer">
        <Button class="cancel" style="width:100px;height:56px;margin-right:16px;" @click="cancelCallPatient">没有</Button>
        <Button class="sure" type="primary" @click="sureCallPatient" :loading="sureCallLoading" style="width:100px;height:56px;">是的</Button>
      </div>
    </Modal>
    <Modal title="设置工作人" v-model="showSetWorker" :footer="null" :width="720" :height="520">
      <setWorker v-if="showSetWorker" :checkId="setWorkerId" @closeSetWorker="closeSetWorker"></setWorker>
    </Modal>
    <Modal title="完成扫描" v-model="showComplete">
        <h3>患者是否已经完成扫描？</h3>
        <div slot="footer" class="footer">
          <Button class="cancel" style="width:100px;height:56px;margin-right:16px;" @click="cancelComScan">没有</Button>
          <Button class="sure" style="width:100px;height:56px;" type="primary" @click="sureComScan" :loading="sureComLoading">是的</Button>
        </div>
    </Modal>
    <Modal title="取消扫描" v-model="showCancel">
        <h3>是否取消本次扫描，让患者回到等待叫号状态？</h3>
        <div slot="footer" class="footer">
          <Button class="cancel" @click="cancelScan" style="width:100px;height:56px;margin-right:16px;">没有</Button>
          <Button class="sure" type="primary" @click="sureCancelScan" :loading="sureCancelLoading" style="width:100px;height:56px;">是的</Button>
        </div>
    </Modal>
    <Modal title="相关资料" v-model="relevantInfomation.openFlag" v-if="relevantInfomation.openFlag" class="callNumPageRelevant" :width="670">
      <viewer :images="relevantInfomation.fileList">
        <img v-for="src in relevantInfomation.fileList" :src="src" :key="src" width="200" style="margin-right: 10px; margin-bottom: 10px; cursor:pointer;">
      </viewer>
      <div slot="footer">
        <Button size="large" @click="closeRelevantModal" style="width:100px;height:56px;">返回</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { callScanning, successScanning, cancelScanning } from '../../api/check'
import setWorker from './setWorker'
import { Button, Row, Col, Tabs, DatePicker, Card, Modal, Icon, } from 'ant-design-vue'
import { queueUpList, getCheckItemInfo } from '../../api/reservation'
import queueLists from '../../components/queueLists/index'
import { mapActions } from 'vuex'
import { getReservationDate, toast, switchTimeFormat, getSession } from '../../libs/utils'
import MateImage from './mateImage'
import { QueueList } from '../../libs/mixin'
import { getProcessType } from '../../core/filter.js'
import { changePrinter } from '../../api/report'
import { getAiCheckImageCenterId } from '../../config'
export default {
  mixins: [QueueList],
  components: {
    Button,
    Row,
    Col,
    Tabs,
    TabPane: Tabs.TabPane,
    DatePicker,
    Card,
    queueLists,
    MateImage,
    setWorker,
    Modal,
    Icon,
  },
  data () {
    return {
      dataSource: [], //预约列表
      selectItem: {}, //选择的排队项目
      queueDate: getReservationDate(),
      showMateImage: false,
      checkOrderId: '',
      showSetWorker: false,
      showCallPatient: false,
      showComplete: false,
      showCancel: false,
      setWorkerId: null,
      relevantInfomation: { // 相关资料
        openFlag: false,
        fileList: []
      },
      staticData: {
        callNum: 0,
        todayCheckNum: 0,
      },
      callNum: 0,
      todayCheckNum: 0,
      time: null,
      sureCallLoading: false,
      sureCancelLoading: false,
      sureComLoading: false
    }
  },
  async mounted () {
    this.role = getSession('userAuth', 'object').roles || null
    await this.initData()
  },
  beforeDestroy () {
    clearInterval(this.time)
    this.time = null
  },
  methods: {
    ...mapActions(['setCurDevice']),
    // 获取排队检查的列表
    async initData () {
      this.selectItem = {}
      await this.getQuenuList(this.defaultDeviceId)
    },
    // 自动刷新列表
    async autoGetList () {
      this.callNum = 0
      this.todayCheckNum = 0
      let params = {
        medicalImageCenterId: this.currentCenterId,
        medicalImageCenterDeviceId: this.defaultDeviceId || (this.devices && this.devices[0] && this.devices[0]['id']),
        queueUpDate: this.queueDate.format('YYYY-MM-DD'),
        isNurse: false
      }
      let data = await queueUpList(params)
      if (data) {
        data.nowCreateQueueUpList.list.forEach(val => {
          if (val.queueUpItemList && val.queueUpItemList.length === 1) {
            val.queueUpItemList.forEach(item => {
              this.forOldData(val, item, 0)
            })
          } else if (val.queueUpItemList && val.queueUpItemList.length > 1) {
            this.forMuchData(val, 0)
          } else if (!val.queueUpItemList) {
            this.forNullData(val, 0)
          }
          this.queueListStatic(val)
        })
        data.nextCreateQueueUpList.list.forEach(val => {
          if (val.queueUpItemList && val.queueUpItemList.length === 1) {
            val.queueUpItemList.forEach(item => {
              this.forOldData(val, item, 1)
            })
          } else if (val.queueUpItemList && val.queueUpItemList.length > 1) {
            this.forMuchData(val, 1)
          } else if (!val.queueUpItemList) {
            this.forNullData(val, 1)
          }
          this.queueListStatic(val)
        })
      }
    },
    // 目标数据不存在
    forNullData (newData, type) {
      this.dataSource && this.dataSource[type] && this.dataSource[type].list && this.dataSource[type].list.forEach(key => {
        if (key.queueUpItemList && !newData.queueUpItemList) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        }
        return
      })
    },
    // 目标数据为null or one 自动刷新循环oldData
    forOldData (newData, oldData, type) {
      this.dataSource && this.dataSource[type] && this.dataSource[type].list.forEach(key => {
        if (key.queueUpItemList && key.queueUpItemList.length === 1) {
          for (let i = 0, len = key.queueUpItemList.length; i < len; i++) {
            if (newData.timer === this.handelTime(key.timer) && key.queueUpItemList[i].checkOrderId === oldData.checkOrderId) {
              Object.assign(key.queueUpItemList[i], oldData)
            }
          }
        } else if (!key.queueUpItemList) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        } else if (key.queueUpItemList && key.queueUpItemList.length > 1) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        }
        this.forReportList(key)
      })
    },
    // 目标数据为多个自动刷新循环oldData
    forMuchData (newData, type) {
      this.dataSource && this.dataSource[type] && this.dataSource[type].list.forEach(key => {
        if (key.queueUpItemList) {
          if (newData.timer === this.handelTime(key.timer)) {
            key.queueUpItemList = newData.queueUpItemList
          }
        }
        this.forReportList(key)
      })
    },
    // 关闭匹配影像弹框
    async handleCancel () {
      this.showMateImage = false
    },
    // 截取时间转化为数字
    handelTime (time) {
      let newTime = time.toString().replace(':', '')
      return +newTime
    },
    // 获取排队列表
    async getQuenuList (deviceId) {
      if (this.time) {
        clearInterval(this.time)
        this.time = null
      }
      this.dataSource = []
      this.callNum = 0
      this.todayCheckNum = 0
      let params = {
        medicalImageCenterId: this.currentCenterId,
        medicalImageCenterDeviceId: deviceId || (this.devices && this.devices[0] && this.devices[0]['id']),
        queueUpDate: this.queueDate.format('YYYY-MM-DD'),
        isNurse: false
      }
      let data = await queueUpList(params)
      if (data) {
        if (this.time) {
          clearInterval(this.time)
          this.time = null
        }
        this.time = setInterval(async () => {
          await this.autoGetList()
        }, 5000)
      }
      if (data && data.nowCreateQueueUpList && data.nowCreateQueueUpList.list) {
        let interval = (this.handelTime(data.nowCreateQueueUpList.list[1].timer)) - (this.handelTime(data.nowCreateQueueUpList.list[0].timer))
        this.formatData(data.nowCreateQueueUpList.list)
        data.nowCreateQueueUpList.list.forEach(val => {
          this.addCurTimeLine(interval, val)
          this.forListAddActive(val)
          this.forReportList(val)
          this.queueListStatic(val)
        })
        this.$set(this.dataSource, 0, data.nowCreateQueueUpList)
      }
      if (data && data.nextCreateQueueUpList && data.nextCreateQueueUpList.list){
        let interval = (this.handelTime(data.nowCreateQueueUpList.list[1].timer)) - (this.handelTime(data.nowCreateQueueUpList.list[0].timer))
        this.formatData(data.nextCreateQueueUpList.list)
        data.nextCreateQueueUpList.list.forEach(val => {
          this.addCurTimeLine(interval, val)
          this.forListAddActive(val)
          this.forReportList(val)
          this.queueListStatic(val)
        })
        this.$set(this.dataSource, 1, data.nextCreateQueueUpList)
      }
    },
    // 遍历排队表 判断当前时间线的显示
    addCurTimeLine (interval, data) {
      let nowDate = switchTimeFormat(new Date(), 7)
      let time = nowDate.slice(0, 5).toString().replace(':', '')
      if ((+time - this.handelTime(data.timer)) >= 0 && (+time - this.handelTime(data.timer)) < interval) {
        data.showLine = true
      } else {
        data.showLine = false
      }
    },
    // 遍历排队表 添加active
    forListAddActive (arr) {
      for (let i = 0, len = arr.queueUpItemList && arr.queueUpItemList.length; i < len; i++) {
        if (arr.queueUpItemList[i].checkOrderId === this.selectItem.checkOrderId) {
          arr.active = true
          this.selectItem = arr.queueUpItemList[i]
          return
        } else arr.active = false
      }
    },
    // 遍历报告列表 让打印机图标显示和统计
    forReportList (arr) {
      arr.queueUpItemList && arr.queueUpItemList.forEach(key => {
        if (key.reportList && key.reportList.length > 0) {
          key.reportList.forEach(item => {
            key.showPrinter = true
            key.reportId = item.reportId
            if (item.isPrinted) {
              key.isPrinted = false
            } else if (item.isPrinted === false) {
              key.isPrinted = true
            }
          })
        } else {
          key.isPrinted = null
          key.showPrinter = false
          key.reportId = null
        }
      })
    },
    // 遍历排队表统计
    queueListStatic (arr) {
      arr.queueUpItemList && arr.queueUpItemList.forEach(key => {
        if (key.status === 10) this.callNum += 1
        this.todayCheckNum += 1
      })
      this.$set(this.staticData, 'callNum', this.callNum)
      this.$set(this.staticData, 'todayCheckNum', this.todayCheckNum)
    },
    // 呼叫患者
    async callPatient () {
      if (!this.checkSelectQueueItem()) return false
      this.showCallPatient = true
    },
    // 设置工作人员
    setWorkMan () {
      if (!this.selectItem.checkOrderId) {
        return toast({ title: '提示', msg: '请选中列表中的其中一个检查！', type: 'warning' })
      }
      this.setWorkerId = { id: this.selectItem.checkOrderId, isCancel: true }
      this.showSetWorker = true
    },
    //编辑详情
    editCheck () {
      if (!this.checkSelectQueueItem()) return false
      if (this.currentCenterId == getAiCheckImageCenterId()) {
        let risUserInfo = getSession('risUserInfo', 'object')
        if (!risUserInfo) return false
        if (this.selectItem.creatorId !== risUserInfo.id) return toast({ title: '提示', type: 'warning', msg: '请选择自己创建的检查单！' })
      }
      this.$router.push({path: '/ris/addCheck', query: {checkOrderId: this.selectItem.checkOrderId, from: 'callNum'}})
    },
    // 匹配影像
    async mateImage () {
      if (!this.checkSelectQueueItem()) return false
      this.showMateImage = true
      this.checkOrderId = this.selectItem.checkOrderId
    },
    // 查看资料
    async seeMessage () {
      if (!this.checkSelectQueueItem()) return false
      let data = await getCheckItemInfo({orderCheckId: this.selectItem.checkOrderId})
      if (data && data.length >= 1) {
        this.relevantInfomation.fileList = data
        this.relevantInfomation.openFlag = true
      } else {
        toast({msg: '暂无相关资料信息', type: 'warning', title: '提示'})
      }
    },
    // 完成扫描
    completeScanning () {
      if (!this.checkSelectQueueItem()) return false
      this.showComplete = true
    },
    // 取消扫描
    cancelScanning () {
      if (!this.checkSelectQueueItem()) return false
      this.showCancel = true
    },
    // 打印报告
    async printReport () {
      if (!this.selectItem.checkOrderId) return toast({ title: '提示', type: 'warning', msg: '请选中其中一项检查！' })
      let data = await changePrinter({ reportId: this.selectItem.reportId })
      if (data) {
        this.$router.push({path: '/ris/printReport', query: { reportId: this.selectItem.reportId }})
      }
    },
    // 选择某一项
    selectTableItem (record) {
      this.selectItem = record
      this.setWorkerId = { id: record.checkOrderId }
    },
    // 关闭匹配影像的弹框
    closeModal () {
      this.showMateImage = false
    },
    // 没有进入检查室
    cancelCallPatient () {
      this.showCallPatient = false
    },
    // 确定进入检查室
    async sureCallPatient () {
      if (!this.checkSelectQueueItem()) return false
      if (this.sureCallLoading) return false
      this.sureCallLoading = true
      let data = await callScanning({ id: this.selectItem.checkOrderId })
      if (data) {
        toast({ msg: '患者进入检查室成功', title: '提示', type: 'success' })
        this.showCallPatient = false
        await this.initData()
      }
      this.sureCallLoading = false
    },
    // 关闭设置工作人弹框
    closeSetWorker () {
      this.showSetWorker = false
    },
    // 关闭完成扫描弹框
    cancelComScan () {
      this.showComplete = false
    },
    // 确定完成扫描
    async sureComScan () {
      if (this.sureComLoading) return false
      this.sureComLoading = true
      let data = await successScanning({ id: this.selectItem.checkOrderId })
      if (data) {
        toast({ msg: '完成扫描成功！', title: '提示', type: 'success' })
        await this.initData()
        this.sureComLoading = false
        this.showComplete = false
        await this.initData()
      }
    },
    // 确定取消扫描
    async sureCancelScan () {
      if (this.sureCancelLoading) return false
      this.sureCancelLoading = true
      let data = await cancelScanning({ id: this.selectItem.checkOrderId })
      if (data) {
        toast({ msg: '取消扫描成功！', title: '提示', type: 'success' })
        await this.initData()
        this.sureCancelLoading = false
        this.showCancel = false
        await this.initData()
      }
    },
    // 关闭取消扫描的弹框
    cancelScan () {
      this.showCancel = false
    },
    checkSelectQueueItem () {
      if (!this.selectItem.checkOrderId) {
        toast({ title: '提示', msg: '请选中列表中的其中一个检查！', type: 'warning' })
        return false
      }
      return true
    },
    closeRelevantModal () {
      this.relevantInfomation.openFlag = false
    },
    // 处理后处理报告类型
    afterHandler (num) {
      return getProcessType(num)
    },
    // 判断角色
    isRole (code) {
      if (!this.role || this.role.length <= 0) return
      for (let i = 0; i < this.role.length; i++) {
        if (this.role[i].rcode === code) return true
      }
    }
  },
  watch: {
    async showMateImage (newVal) {
      if (!newVal) {
        await this.initData()
      }
    }
  }
}
</script>
<style lang="less">
@import url('../../style/index.less');
.callNumPage{
  background-color: @pageBgColor;
  margin: @LeaveDistance;
  .callNumPageRow{
    overflow: auto;
    margin: 0 !important;
    display: flex;
    width: 100%;
    height: 100%;
  }
  .leftContent{
    padding: 0 @LeaveDistance;
    background: #ffffff;
    margin-bottom: @LeaveDistance;
    flex: 1;
    .calendarWrap{
      display:flex;
      align-items:center;
      margin-top: 6px;
    }
  }
  @media all and (max-width: 1090px) {
    .rightContent{
      max-width: 252px;
      height: 400px;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-left: 16px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      .static{
        height: 45px;
        .ant-card-body{
          padding: 0;
        }
        .pageNumShow{
          line-height: 45px;
          margin-left: @LeaveDistance;
          width: 100%;
        }
      }
      .ant-card-body{
        padding: @LeaveDistance;
      }
      .mainOperate{
        border:none;
        button{
          width: @mainBtnWidth;
          height: @mainBtnHeight;
        }
      }
      .operateCard{
        border:none;
        .ant-card-body{
          padding: 0;
        }
        button{
          width: @auxiliaryBtnWidth;
          height: @auxiliaryBtnHeight;
          margin-left: @LeaveDistance;
          margin-bottom: @LeaveDistance;
        }
      }
    }
  }
  @media all and (min-width: 1090px) {
    .rightContent{
      max-width: 252px;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-left: 16px;
      overflow-x: hidden;
      overflow-y: auto;
      background-color: #fff;
      .static{
        height: 45px;
        .ant-card-body{
          padding: 0;
        }
        .pageNumShow{
          line-height: 45px;
          margin-left: @LeaveDistance;
          width: 100%;
        }
      }
      .ant-card-body{
        padding: @LeaveDistance;
      }
      .mainOperate{
        border:none;
        button{
          width: @mainBtnWidth;
          height: @mainBtnHeight;
        }
      }
      .operateCard{
        border:none;
        .ant-card-body{
          padding: 0;
        }
        button{
          width: @auxiliaryBtnWidth;
          height: @auxiliaryBtnHeight;
          margin-left: @LeaveDistance;
          margin-bottom: @LeaveDistance;
        }
      }
    }
  }
  .checkPatient{
    border-bottom: none;
    height: 100%;
    overflow-y: auto;
  }
}
.watchSlideRelevantInfo();

</style>